import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/HomeComponent'
import About from '@/components/AboutComponent'
import References from '@/components/ReferencesComponent'
import Privacy from '@/components/PrivacyComponent'

Vue.use(Router)

export default new Router({
    routes: [
        { path: '*', redirect: '/' },
        { path: '/', component: Home },
        { path: '/about', component: About },
        { path: '/references', component: References },
        { path: '/privacy', component: Privacy }
    ],
    mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js